<script>
  import { getContext, onMount } from 'svelte'
  import { parseRGB } from './helpers'
  import { SELECTED_COLOR_KEY } from './ChromaPicker.svelte'

  const selectedColor = getContext(SELECTED_COLOR_KEY)

  let colorCanvas
  let colorCtx
  let colorMarker

  const handleColorClick = event => {
    const canvasDimensions = colorCanvas.getBoundingClientRect()

    const x = event.clientX - canvasDimensions.left
    const pixel = colorCtx.getImageData(x, 0, 1, 1)['data'] // Read pixel Color

    const rgb = `rgb(${pixel[0]},${pixel[1]},${pixel[2]})`

    selectedColor.change({ rgb }, $selectedColor)
    colorMarker.style.left = `${event.clientX}px`
    colorMarker.style.backgroundColor = rgb
  }

  const createColorCanvas = () => {
    colorCtx = colorCanvas.getContext('2d') // This create a 2D context for the canvas

    let gradientH = colorCtx.createLinearGradient(0, 0, colorCtx.canvas.width, 0)
    gradientH.addColorStop(0, 'rgb(252, 0, 63)')
    gradientH.addColorStop(0.2, 'rgb(229, 0, 255)')
    gradientH.addColorStop(0.4, 'rgb(0, 63, 255)')
    gradientH.addColorStop(0.6, 'rgb(0, 255, 237)')
    gradientH.addColorStop(0.8, 'rgb(55, 255, 0)')
    gradientH.addColorStop(1, 'rgb(255, 225, 0)')

    colorCtx.fillStyle = gradientH
    colorCtx.fillRect(0, 0, colorCtx.canvas.width, colorCtx.canvas.height)
  }

  const setColorInCanvas = () => {
    const canvasWidth = colorCanvas.width
    const y = 0

    // Convert the target color to an RGB array
    const targetRGBA = parseRGB($selectedColor.rgb)

    for (let x = 0; x < canvasWidth; x++) {
      const pixelData = colorCtx.getImageData(x, y, 1, 1)['data'] // Read pixel Color

      const pixelColor = [
        pixelData[0], // Red
        pixelData[1], // Green
        pixelData[2] // Blue
      ]

      if (compareColorArray(targetRGBA, pixelColor)) {
        colorMarker.style.left = `${x - 20}px`
      }
    }

    // If the color is not found, return null
    return null
  }

  const compareColorArray = (target, pixel) => {
    let result = true
    for (let i = 0; i < target.length; i++) {
      if (target[i] === pixel[i] || Math.abs(target[i] - pixel[i]) <= 80) {
      } else {
        result = false
      }
    }
    return result
  }

  $: if ($selectedColor && colorCanvas) {
    setColorInCanvas()
  }

  onMount(() => createColorCanvas())
</script>

<canvas
  width="300px"
  height="25px"
  id="color_canvas"
  class="canvas"
  bind:this={colorCanvas}
  on:click={e => handleColorClick(e)}
/>
<div id="color_marker" class="marker" bind:this={colorMarker} />
